// extracted by mini-css-extract-plugin
module.exports = {"card":"ArticlesCards_card__LjuWa","title":"ArticlesCards_title__AFDDL","noto_sans_hebrew":"ArticlesCards_noto_sans_hebrew__J8IYJ"};